import superagent from 'superagent'

import config from '../../config'

export default {
    get,
}

async function get() {
    const res = await superagent.get(config.url_api + '/region')
    if (res.status != 200) {
        throw new Error('Can not load regions. Please try again later')
    }

    const regions = res.body.map(r => {
        return { code: r, name: r }
    })
    return regions
}
